<template>
    <div>
        <ion-card class="-light">
            <ion-list-header>Angaben zum eigenen KFZ</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col size="12">
                        <base-select
                            :value="kfzart"
                            id="kfzart"
                            label="Fahrzeugtyp"
                            @input="$emit('update:kfzart', $event)"
                            :disabled="isKfzartDisabled"
                        >
                            <ion-select-option value="PKW"
                                >PKW</ion-select-option
                            >
                            <ion-select-option value="LKW"
                                >LKW</ion-select-option
                            >
                            <ion-select-option value="Motorrad"
                                >Motorrad</ion-select-option
                            >
                        </base-select>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12">
                        <base-input
                            id="kfzmarke"
                            :value="kfzmarke"
                            type="text"
                            label="Marke *"
                            @input="$emit('update:kfzmarke', $event)"
                            :disabled="isKfzmarkeDisabled"
                        ></base-input>
                    </ion-col>
                    <ion-col size="12">
                        <base-input
                            id="kmstand"
                            :value="kmstand"
                            type="text"
                            label="Km-Stand"
                            @input="$emit('update:kmstand', $event)"
                            inputmode="decimal"
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row class="ion-margin-top">
                    <ion-col>
                        <ion-item lines="none">
                            <ion-label text-wrap
                                >War ein weiteres KFZ beteiligt?</ion-label
                            >
                            <base-toggle
                                :value="isOtherKfzInvolved"
                                @input="
                                    $emit('update:isOtherKfzInvolved', $event)
                                "
                                id="beteiligt-toggle"
                            ></base-toggle>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <ion-card class="-light" v-if="isOtherKfzInvolved">
            <ion-list-header>Angaben zum beteiligten KFZ</ion-list-header>
            <ion-grid>
                <ion-row>
                    <ion-col size="12">
                        <base-select
                            :value="beteiligtKfzart"
                            id="beteiligt-kfzart"
                            label="Fahrzeugtyp"
                            @input="$emit('update:beteiligtKfzart', $event)"
                        >
                            <ion-select-option value="PKW"
                                >PKW</ion-select-option
                            >
                            <ion-select-option value="LKW"
                                >LKW</ion-select-option
                            >
                            <ion-select-option value="Motorrad"
                                >Motorrad</ion-select-option
                            >
                        </base-select>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12">
                        <base-input
                            id="beteiligt-kfzmarke"
                            :value="beteiligtKfzmarke"
                            type="text"
                            label="Marke"
                            @input="$emit('update:beteiligtKfzmarke', $event)"
                        ></base-input>
                    </ion-col>
                    <ion-col size="12">
                        <base-input
                            id="beteiligt-kennzeichennummer"
                            :value="beteiligtKennzeichennummer"
                            type="text"
                            label="Kennzeichen"
                            @input="
                                $emit(
                                    'update:beteiligtKennzeichennummer',
                                    $event
                                )
                            "
                        ></base-input>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="12">
                        <base-input
                            id="beteiligt-kfzversicherung"
                            :value="beteiligtKfzversicherung"
                            type="text"
                            label="KFZ-Versicherung bei"
                            @input="
                                $emit('update:beteiligtKfzversicherung', $event)
                            "
                        ></base-input>
                    </ion-col>
                    <ion-col size="12">
                        <base-input
                            id="beteiligt-polizze"
                            :value="beteiligtPolizze"
                            type="text"
                            label="Polizzen-Nr."
                            @input="$emit('update:beteiligtPolizze', $event)"
                        ></base-input>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
    </div>
</template>

<script>
import BaseSelect from "@/components/BaseSelect";
import BaseInput from "@/components/BaseInput";
import BaseToggle from "@/components/BaseToggle";

export default {
    components: {
        BaseSelect,
        BaseInput,
        BaseToggle,
    },
    props: {
        kfzart: {
            required: true,
            type: String,
        },
        isKfzartDisabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        kfzmarke: {
            required: true,
            type: String,
        },
        isKfzmarkeDisabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        kmstand: {
            required: true,
            type: String,
        },
        beteiligtKfzart: {
            required: true,
            type: String,
        },
        beteiligtKfzmarke: {
            required: true,
            type: String,
        },
        beteiligtKennzeichennummer: {
            required: true,
            type: String,
        },
        beteiligtKfzversicherung: {
            required: true,
            type: String,
        },
        beteiligtPolizze: {
            required: true,
            type: String,
        },
        isOtherKfzInvolved: {
            required: true,
            type: Boolean,
        },
    },
};
</script>

<style></style>
